import { RoleApi } from "generated/apiUsers";
import { Configuration } from "generated/configuration";
import { getLoggedinUser } from "helpers/api_helper";

const { REACT_APP_API_URL } = process.env;

export const fetchRoles = {
  queryFn: async () => {
    const authUser: any = getLoggedinUser();

    const api = new RoleApi(
      new Configuration({
        accessToken: authUser.accessToken || "",
        basePath: `${REACT_APP_API_URL}`,
      })
    );

    const response = await api.roleControllerRead();
    const filteredRoles = response.data.filter((role: any) => {
      if (role.code !== "SUPERADMIN") {
        return true;
      }
      return false;
    });
    const roles = filteredRoles.map((role: any) => {
      return {
        label: role.title,
        value: role.id,
      };
    });

    return roles;
  },
  queryKey: () => ["fetchRoles"],
};


export const fetchRegisterRoles = {
  queryFn: async () => {
    const api = new RoleApi(
      new Configuration({
        basePath: `${REACT_APP_API_URL}`,
      })
    );

    const response = await api.roleControllerReadForRegister();
    const filteredRoles = response.data.filter((role: any) => {
      if (role.code !== "SUPERADMIN" && role.code !== "MANAGER") {
        return true;
      }
      return false;
    });
    const roles = filteredRoles.map((role: any) => {
      return {
        label: role.title,
        value: Number(role.id),
      };
    });

    return roles;
  },
  queryKey: () => ["fetchRegisterRoles"],
};